import axios from "../api";
export const getObjectiveGroups = async () => {
    const res = await axios.get("/objectives/groups");
    return res.data;
};
//# sourceMappingURL=getObjectiveGroups.js.map